const key = 'DEVICES__';

exports.SET_CREATE_EDIT_DEVICES = `${key}SET_CREATE_EDIT_DEVICES`;
exports.SET_DEVICES_ID_TO_EDIT = `${key}SET_DEVICES_ID_TO_EDIT`;
exports.SET_ID_BUSINESS_TYPE = `${key}SET_ID_BUSINESS_TYPE`;
exports.SET_DEVICES_LOGS = `${key}SET_DEVICES_LOGS`;

exports.SET_CREATE_EDIT_GATEWAY = `${key}SET_CREATE_EDIT_GATEWAY`;
exports.SET_GATEWAY_ID_TO_EDIT = `${key}SET_GATEWAY_ID_TO_EDIT`;

exports.SET_IS_EDIT_DEFAULT = `${key}SET_IS_EDIT_DEFAULT`;
exports.SET_CREATE_EDIT_VALUES = `${key}SET_CREATE_EDIT_VALUES`;
exports.ADD_CREATE_EDIT_VALUES_GROUP_CONDITIONS = `${key}ADD_CREATE_EDIT_VALUES_GROUP_CONDITIONS`;
exports.REMOVE_CREATE_EDIT_VALUES_GROUP_CONDITIONS = `${key}REMOVE_CREATE_EDIT_VALUES_GROUP_CONDITIONS`;
exports.ADD_CREATE_EDIT_VALUES_OR_CONDITION = `${key}ADD_CREATE_EDIT_VALUES_OR_CONDITION`;
exports.REMOVE_CREATE_EDIT_VALUES_OR_CONDITION = `${key}REMOVE_CREATE_EDIT_VALUES_OR_CONDITION`;
exports.CHANGE_CREATE_EDIT_VALUES_OR_CONDITION = `${key}CHANGE_CREATE_EDIT_VALUES_OR_CONDITION`;

exports.ADD_CREATE_EDIT_VALUES_ACTION = `${key}ADD_CREATE_EDIT_VALUES_ACTION`;
exports.REMOVE_CREATE_EDIT_VALUES_ACTION = `${key}REMOVE_CREATE_EDIT_VALUES_ACTION`;
exports.CHANGE_CREATE_EDIT_VALUES_ACTION = `${key}CHANGE_CREATE_EDIT_VALUES_ACTION`;

exports.SET_DEVICES_LIST = `${key}SET_DEVICES_LIST`;
exports.START_DELETING_DEVICE = `${key}START_DELETING_DEVICE`;
exports.DELETE_DEVICE = `${key}DELETE_DEVICE`;
exports.ADD_DEVICE = `${key}ADD_DEVICE`;
exports.SET_DEVICE_COUNT = `${key}SET_DEVICE_COUNT`;
exports.EDIT_DEVICE = `${key}EDIT_DEVICE`;
exports.SET_DEVICE_LIST = `${key}SET_DEVICE_LIST`;
exports.RESET_OFFSET = `${key}RESET_OFFSET`;
exports.SET_SEARCH = `${key}SET_SEARCH`;
exports.RESET_DEVICES = `${key}RESET_DEVICES`;

// exports.SET_IS_EDIT_DEFAULT = `${key}SET_IS_EDIT_DEFAULT`;
// exports.SET_CREATE_EDIT_VALUES = `${key}SET_CREATE_EDIT_VALUES`;
// exports.ADD_CREATE_EDIT_VALUES_GROUP_CONDITIONS =
// `${key}ADD_CREATE_EDIT_VALUES_GROUP_CONDITIONS`;
// exports.REMOVE_CREATE_EDIT_VALUES_GROUP_CONDITIONS =
// `${key}REMOVE_CREATE_EDIT_VALUES_GROUP_CONDITIONS`;
// exports.ADD_CREATE_EDIT_VALUES_OR_CONDITION = `${key}ADD_CREATE_EDIT_VALUES_OR_CONDITION`;
// exports.REMOVE_CREATE_EDIT_VALUES_OR_CONDITION = `${key}REMOVE_CREATE_EDIT_VALUES_OR_CONDITION`;
// exports.CHANGE_CREATE_EDIT_VALUES_OR_CONDITION = `${key}CHANGE_CREATE_EDIT_VALUES_OR_CONDITION`;

// exports.ADD_CREATE_EDIT_VALUES_ACTION = `${key}ADD_CREATE_EDIT_VALUES_ACTION`;
// exports.REMOVE_CREATE_EDIT_VALUES_ACTION = `${key}REMOVE_CREATE_EDIT_VALUES_ACTION`;
// exports.CHANGE_CREATE_EDIT_VALUES_ACTION = `${key}CHANGE_CREATE_EDIT_VALUES_ACTION`;

// exports.SET_DEVICES_LIST = `${key}SET_DEVICES_LIST`;
// exports.START_DELETING_DEVICE = `${key}START_DELETING_DEVICE`;
// exports.DELETE_DEVICE = `${key}DELETE_DEVICE`;
// exports.ADD_DEVICE = `${key}ADD_DEVICE`;
// exports.SET_DEVICE_COUNT = `${key}SET_DEVICE_COUNT`;
// exports.EDIT_DEVICE = `${key}EDIT_DEVICE`;
// exports.RESET_OFFSET = `${key}RESET_OFFSET`;
// exports.SET_SEARCH = `${key}SET_SEARCH`;
// exports.RESET_DEVICES = `${key}RESET_DEVICES`;
